import { Injectable } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import * as ExcelJS from 'exceljs';
 
@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor() { }
  public exportExcel(jsonData: any[], excelHeader: any, fileName: string, showRows: number[] = []): void {
    this.onExportExcel(jsonData, excelHeader, fileName, showRows);
  }
 
  private async onExportExcel(jsonData: any[], excelHeader: any, fileName: string, showRows: number[] = []) {
 
    let dataRows: any[] = [];
    let cells: any[] = [];
 
    // Header Row Adding
    excelHeader.forEach((x: string) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      });
      dataRows.push(cells);
    });
 
    // Value Row Adding
    jsonData.forEach((x: any) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      })
 
      dataRows.push(cells);
    });
 
    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');
 
    for (let i = 0; i < dataRows.length; i += 1000) {
      const batch = dataRows.slice(i, i + 1000);
      worksheet.addRows(batch);
      await new Promise(resolve => setTimeout(resolve, 0)); // Yield to the event loop
    }
 
    // Hide all rows except those in showRows (jsonData indices, header always shown)
    if (showRows && showRows.length > 0) {
      // Always show header (row 1), and map showRows to 1-based ExcelJS rows (add 2)
      const validShowRows = [1, ...showRows.map(i => i + 2).filter(i => i > 1 && i <= worksheet.rowCount)];
      const totalRows = worksheet.rowCount;
      for (let i = 1; i <= totalRows; i++) {
        if (!validShowRows.includes(i)) {
          worksheet.getRow(i).hidden = true;
        }
      }
    }
 
    // Auto width for columns based on max length in each column, with a reasonable max width
    const MAX_COL_WIDTH = 50;
    worksheet.columns.forEach((column: any) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
      let cellValue = cell.value;
      if (cellValue == null) cellValue = '';
      else if (typeof cellValue !== 'string') cellValue = cellValue.toString();
      maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = Math.min(maxLength + 2, MAX_COL_WIDTH);
    });
 
    // Finalize workbook to optimize styles
    this.finalizeWorkbook(workbook);
 
    await workbook.xlsx.writeBuffer().then(buffer => {
      let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, fileName);
    }).catch()
      .finally(() => {
 
      });
  }
 
  finalizeWorkbook(workbook: ExcelJS.Workbook) {
    const internedStyles = new Map();
    workbook.worksheets.forEach(worksheet => {
      worksheet.eachRow(row => {
        row.eachCell(cell => {
          const styleKey = JSON.stringify(cell.style);
          if (!internedStyles.has(styleKey)) {
            internedStyles.set(styleKey, Object.freeze({ ...cell.style }));
          }
          cell.style = internedStyles.get(styleKey);
        });
      });
    });
  }
}